import React, { useState, useEffect } from "react";
import { useIdleTimer } from 'react-idle-timer'
import { useSelector } from "react-redux";
import SessionTimeoutDialog from "./SessionTimeoutDialog";

// Segundos de cuenta regresiva del diálogo antes de cerrar la sesión
const PROMPT_SECONDS = 10;

const SessionTimeout = ({ isAuthenticated, logOut }) => {
  const [timeoutModalOpen, setTimeoutModalOpen] = useState(false);
  const [timeoutCountdown, setTimeoutCountdown] = useState(0);
  const settingsStore = useSelector(state => state.settings);

  const handleLogout = () => {
    try {
      setTimeoutModalOpen(false);
      logOut();
    } catch (err) {
      console.error(err);
    }
  };

  const onPrompt = () => {
    if (isAuthenticated) {
      setTimeoutModalOpen(true);
    }
  };

  const onIdle = () => {
    if (isAuthenticated) {
      handleLogout();
    }
  };

  // Al volver a estar activo (en esta u otra pestaña) se cierra el diálogo
  const onActive = () => {
    setTimeoutModalOpen(false);
  };

  // crossTab: la actividad en cualquier pestaña de la aplicación mantiene viva la sesión en todas.
  // Los tiempos se calculan por timestamps, por lo que funcionan aunque la pestaña esté oculta.
  const { getRemainingTime, activate } = useIdleTimer({
    onPrompt,
    onIdle,
    onActive,
    timeout: settingsStore.isLoading ? 900000 : settingsStore.settings.inactivityTime,
    promptTimeout: PROMPT_SECONDS * 1000,
    crossTab: true,
    syncTimers: 200,
    debounce: 250,
  });

  useEffect(() => {
    if (!timeoutModalOpen) return;

    const updateCountdown = () => setTimeoutCountdown(Math.ceil(getRemainingTime() / 1000));
    updateCountdown();
    const countdownInterval = setInterval(updateCountdown, 500);

    return () => clearInterval(countdownInterval);
  }, [timeoutModalOpen, getRemainingTime]);

  const handleContinue = () => {
    setTimeoutModalOpen(false);
    activate();
  };

  return (
    <>
      <SessionTimeoutDialog
        countdown={timeoutCountdown}
        onContinue={handleContinue}
        onLogout={handleLogout}
        open={timeoutModalOpen}
      />
    </>
  );
}

export default SessionTimeout;
